import * as React from 'react';
const SvgLessonCalendar = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 15 11" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 11V8h3.001v3H4zm0-4V4h3v3H4zm-4 4V8h3v3H0zm0-4V3.999h3V7H0zm8 0V4h3v3H8zm0 4V8h3v3H8zm0-8V0h3v3H8zm4 4V3.999h3.001V7H12zm0-4V0h3.001v3H12zM4 3V0h3.001v3H4z"
            fill="currentColor"
        />
    </svg>
);
export default SvgLessonCalendar;
